import {
  collection,
  doc,
  setDoc,
  deleteDoc,
  getDoc,
  query,
  where,
  getDocs,
  updateDoc,
  increment,
} from 'firebase/firestore';
import { db } from './firebase';
import { createNotification } from './notificationService';

export const likeArtwork = async (userId: string, userName: string, artworkId: string, artistId: string) => {
  try {
    const likeRef = doc(db, 'likes', `${userId}_${artworkId}`);
    await setDoc(likeRef, {
      userId,
      artworkId,
      createdAt: new Date(),
    });

    // Increment likes count
    const artworkRef = doc(db, 'artworks', artworkId);
    await updateDoc(artworkRef, {
      likes: increment(1),
    });

    // Notify artist (WITHOUT imageUrl to avoid undefined)
    if (userId !== artistId) {
      await createNotification(
        artistId,
        'like',
        'New Like',
        `${userName} liked your artwork`,
        undefined, // Don't pass imageUrl
        `/artwork/${artworkId}`
      );
    }
  } catch (error) {
    console.error('Error liking artwork:', error);
    throw error;
  }
};

export const unlikeArtwork = async (userId: string, artworkId: string) => {
  const likeRef = doc(db, 'likes', `${userId}_${artworkId}`);
  await deleteDoc(likeRef);

  // Decrement likes count
  const artworkRef = doc(db, 'artworks', artworkId);
  await updateDoc(artworkRef, {
    likes: increment(-1),
  });
};

export const isLiked = async (userId: string, artworkId: string): Promise<boolean> => {
  const likeRef = doc(db, 'likes', `${userId}_${artworkId}`);
  const likeDoc = await getDoc(likeRef);
  return likeDoc.exists();
};

export const getLikesCount = async (artworkId: string): Promise<number> => {
  const q = query(
    collection(db, 'likes'),
    where('artworkId', '==', artworkId)
  );
  const querySnapshot = await getDocs(q);
  return querySnapshot.size;
};